<template>
  <div class="headNav">
    <img
      @click="getActive('Inicio')"
      class="logo"
      src="@/assets/image/Inicio/logo.png"
      alt=""
    />
    <ul class="nav">
      <li :class="activeNav == 'Inicio' ? 'active' : ''">
        <a @click="getActive('Inicio')">Inicio</a>
      </li>
      <li :class="activeNav == 'Sobre' ? 'active' : ''">
        <a @click="getActive('Sobre')">Sobre nosotros</a>
      </li>
      <li :class="activeNav == 'Ayuda' ? 'active' : ''">
        <a @click="getActive('Ayuda')">Ayuda</a>
      </li>
      <li :class="index == 1 ? 'active' : ''">
        <a style="color: #e8e8e9" href="">
          <!-- href="https://www.muchamo.com/Muchamo_google_release_v1.0.10_2403191759.apk" -->
          <!-- href="https://prod-peru.obs.na-mexico-1.myhuaweicloud.com/Muchamo_v1.0.9.apk" -->
          Descarga la app
        </a>
      </li>
      <li :class="activeNav == 'Aviso' ? 'active' : ''">
        <a @click="getActive('Aviso')">Política de privacidad</a>
      </li>
      <li :class="activeNav == 'Uso' ? 'active' : ''">
        <a @click="getActive('Uso')">Términos y condiciones de uso</a>
      </li>
      <!-- <li :class="activeNav == 'fraude' ? 'active' : ''">
        <a @click="getActive('fraude')">Evita fraude</a>
      </li>
      <li :class="activeNav == 'libro' ? 'active' : ''">
        <a @click="getActive('libro')">Libro de reclamaciones</a>
      </li> -->
    </ul>
  </div>
</template>

<script>
export default {
  name: "headNav",
  props: ["activeNav"],
  data() {
    return {
      // active: "Inicio",
      index: null,
    };
  },
  created() {
    console.log(this.activeNav);
    // this.active = this.activeNav;
    // console.log(nav, this.active);
    // if (nav) {
    //   this.active = nav;
    // } else {
    //   localStorage.setItem('activeNav', "Inicio");
    // }
  },
  methods: {
    getActive(val) {
      let url = "";
      switch (val) {
        case "Inicio":
          url = "/Inicio";
          break;
        case "Sobre":
          url = "/Sobre";
          break;
        case "Ayuda":
          url = "/Ayuda";
          break;
        case "Aviso":
          url = "/Aviso";
          break;
        case "Uso":
          url = "/Uso";
          break;
        case "fraude":
          url = "/fraude";
          break;
        case "libro":
          url = "/libro";
          break;
      }
      this.$router.push(url);
    },
    handleApp() {
      this.index = 1;
      this.activeNav = "";
      window.open("https://www.ekecash.pe/home");
    },
  },
};
</script>

<style lang="scss" scoped>
.headNav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1253px;
  margin: 0 auto;
  padding-top: 13px;
  img {
    width: 166px;
    margin-right: 220px;
  }
  .nav {
    display: flex;
    li {
      display: flex;
      align-items: center;
      list-style: none;
      margin-right: 35px;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #e8e8e9;
      text-align: center;
      white-space: nowrap;
    }
    .active {
      color: #8a68ff;
    }
  }
}
</style>
